<template>
<div class="grid  mt-4" >	
<div id="ticket_conversation">

<template v-if="ticket.status">
<div class="col-12">
<div class="flex align-items-center justify-content-end">
<Tag 
class="mr-2 mt-2 mb-4"   
:value="$store.state.languages.lang_phrases.cozumlendi" 
style="background-color:#4dc247"
/>
</div>
</div>
</template>
<TicketMessage v-for="message in $store.state.tickets.displaying_ticket.conversations" :message="message">

</TicketMessage>

</div>

<template v-if="!ticket.status">
  <Textarea v-model="description" :autoResize="true" :placeholder="$store.state.languages.lang_phrases.mesaj" rows="3" cols="30" class="w-full p-inputtext-sm mt-3 surface-border" />

<div class="col-12">
<div class="flex align-items-center justify-content-end mt-3">
 <Button type="button"  icon="pi pi-chevron-right" :label="$store.state.languages.lang_phrases.gonder" class="p-button-primary p-button-outlined p-button-sm "  @click="submitAnswer"/> 
</div>

</div>
</template>



</div>
</template>

<script>
export default {

  name: 'TicketConversation',
  props:["ticket"],
  data () {
    return {
    	description:null,
    }
  },
  sockets:{
  	ticket_answer_submitted(data) {
      console.log("%c ticket_answer_submitted ","color:white;background-color:#352f8d;font-weight:light;")
      console.log(data)
      this.$store.dispatch('tickets/setDisplayingTicket',data) 
      setTimeout(()=>{
	        var objDiv = document.getElementById("ticket_conversation");
	        objDiv.scrollTop = objDiv.scrollHeight;
	      },10)
    },
  },
  methods:{
  	submitAnswer()
  	{	
  		//return false
  		let formdata = new FormData()
  		formdata.append("description",this.description.replace(/\n\r?/g, '<br />'))
  		this.generalSubmission(formdata,"tickets/submit_ticket_answer/"+this.$store.state.tickets.displaying_ticket.id,this.aftersubmitAnswer)
  	},
  	aftersubmitAnswer(response)
  	{
  		console.log(response.data)
  		this.$store.dispatch('tickets/setDisplayingTicket',response.data)    	
    	
    	
    	this.description = null
    	 setTimeout(()=>{
	        var objDiv = document.getElementById("ticket_conversation");
	        objDiv.scrollTop = objDiv.scrollHeight;
	      },10)

  		//this.$emit("ticketAdded")
  	}
  }
}
</script>

<style lang="css" scoped>
#ticket_conversation{
	width: 100%;
	height: 60vh;
	overflow-x: hidden;
}

/* ===== Scrollbar CSS ===== */
  /* Firefox */
  #ticket_conversation {
    scrollbar-width: auto;
    scrollbar-color: #352f8d #ffffff;
  }

  /* Chrome, Edge, and Safari */
  #ticket_conversation::-webkit-scrollbar {
    width: 10px;
  }

  #ticket_conversation::-webkit-scrollbar-track {
    background: #ffffff;
  }

  #ticket_conversation::-webkit-scrollbar-thumb {
    background-color: #352f8d;
    border-radius: 10px;
    border: 3px solid #ffffff;
  }
</style>